<p>sales-invoice-detail works!</p>
<div *ngIf="selectedInvoice">
    <p>Invoice number: {{selectedInvoice.invoiceNumber}}</p>
    <p-button icon="pi pi-file-pdf" pTooltip="Download PDF" tooltipPosition="top" (onClick)="downloadSalesInvoice()">
    </p-button>
    <p>Preview of invoice here, coming soon</p>
</div>